import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  results: null,
  reportUrl: null,
  loading: false
}
// Store
export const content = createSlice({
  name,
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    setResults: (state, { payload }) => {
      state.loading = false
      state.results = payload
      state.reportUrl = payload.reportUrl || null
    },
    reset: () => initialState
  }
}
)

export const {
  setLoading,
  setResults,
  reset
} = content.actions

export default content.reducer
